import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import "bootstrap/dist/js/bootstrap.min.js";
import { Router, ReactLocation, Outlet, ReactLocationDevtools } from "./utils/components/router";
import xss from "xss";

import Layout from "./Layout";
import clientConfig from "./clientConfig";
import { configActions, messageActions } from "./actions";
import CONFIG from "./config";
import { console, sendError } from "./utils/functions";
import { ErrorPage } from "./pages";
import routes from "./Routes";
import { RESPONSE_HEADER, YES_RESPONSE_STATUS } from './utils/enums';

require("./themes/" + CONFIG.SHOP_ID + "/settings.scss");

class App extends Component {
  constructor(props) {
    super(props);
    clientConfig.init();
    props.dispatch(configActions.initConfig({
      htmlId: "rechner_SE_SHOP",
      approot: window.location.origin,
      contextRoot: CONFIG.CONTEXT_ROOT
    }));
    this.setInterceptors();
    this.location = new ReactLocation();
    this.setState = this.setState.bind(this);
    this.state = {
      initialized: false,
      loaded: false
    };
    this.routes = routes({ state: this.state, setState: this.setState });
    this.timeout = null;
    this.onResetError = this.onResetError.bind(this);
  }

  setInterceptors() {
    const configStorage = this.props.configStorage;
    let objektheader = configStorage.getRequestHeader();
    axios.defaults.headers.common['request'] = JSON.stringify(objektheader);
    axios.interceptors.request.use(request => {
      let objektheader = configStorage.getRequestHeader();
      // change applicationId wenn die Anfrage aus dem Adminbereich (Konditionen) kommt
      if (request.admin) {
        request.headers.request = JSON.stringify({
          ...objektheader,
          applikationId: request.admin.applikationId
        });
        if (request.data && request.data.header) {
          request.data.header.applikationId = request.admin.applikationId;
        }
        delete request.admin;
      }
      if (request.data && request.data.admin) {
        request.headers.request = JSON.stringify({
          ...objektheader,
          applikationId: request.data.admin.applikationId
        });
        if (request.data.header) {
          request.data.header.applikationId = request.data.admin.applikationId;
        }
        delete request.data.admin;
      }
      axios.defaults.headers.common["request"] = JSON.stringify(objektheader);
      // Edit request config
      return request;
    }, error => {
      console.error("e2", error);
      this.setState({ error: true, errorMsg: xss(error.message) });
    });
    axios.interceptors.response.use(response => {
      if (!response) {
        throw new Error("Übertragungsfehler");
      }
      //im standalone kann es sein, dass kein header mit successful mit geschickt wird
      if ((!response.data || !response.data.header) && response.status < 400) return response;
      // do not intercept mandant load with GPNumber
      if (
        response.config &&
        String(response.config.url).match(/\/mandant\/\d+/) &&
        response.data &&
        response.data.header &&
        "NO_DATA" === response.data.header.status
      ) {
        return response;
      }
      if (
        response.data &&
        response.data.responseStatus !== YES_RESPONSE_STATUS.YES_ERROR_RESPONSE &&
        response.data.header &&
        RESPONSE_HEADER.STATUS.SUCCESSFUL !== response.data.header.status &&
        RESPONSE_HEADER.STATUS.DELTA !== response.data.header.status
      ) {
        // is handled by ErrorBondary
        this.setState({ error: true, errorMsg: xss(`status: ${response.data.header.status} Fehler Nummer: ${response.data.header.errorNr} Meldung: ${response.data.header.errorMsg}`) });
      }
      if (response.status >= 400) {
        // is handled by ErrorBondary
        const message = xss(`status: ${response.status} Meldung: ${response.statusText}`);
        this.setState({ error: true, errorMsg: message });
        this.props.dispatch(messageActions.addMessage(message));
      }
      // on each call to /rage/ the session is reset
      if (response.config && String(response.config.url).match(new RegExp(CONFIG.RAGE_ROOT))) {
        this.props.dispatch(configActions.resetSession());
      }
      return response;
    },
      error => {
        console.error("e3", error.message, error.code);
        if (error.response && error.response.status === 403) {
          const message = xss(` Keine Berechtigung: Sie müssen sich anmelden oder die Sitzung ist abgelaufen`);
          this.setState({ error: true, errorMsg: message });
          this.props.dispatch(messageActions.addMessage(message));
          return {};
        }
        if (error.response && error.response.status === 304) { // upload was not changed
          return {};
        }
        switch (error.code) {
          case "ERR_NETWORK":
            sendError(error, "interceptor");
            throw new Error("e4: Ein Übertragungsfehler ist aufgetreten");
          case "ERR_BAD_REQUEST":
            let message = this.state.errorMsg ? this.state.errorMsg + ", " : "";
            if (error && error.request) {
              message = message + `Übertragungsfehler ${error.request.responseURL}`;
              // handle konditionen in reducer
            } else {
              message = message + error.message;
            }
            message = xss(message);
            if (error.response && error.response.status === 415) {
              sendError(error, "interceptor");
              throw new Error("Der Typ der Datei ist nicht erlaubt");
            }
            if (!this.props.pageStorage.isAdminPage()) {
              this.setState({ error: true, errorMsg: message });
            } else {
              sendError(error, "interceptor");
              throw new Error(message);
            }
            break;
          case "ECONNABORTED":
            return {};
          default:
            sendError(error, "interceptor");
            throw new Error(xss(typeof error === "string" ? error : error.message));
        }
      }
    );
  }

  componentDidMount() {
    if (this.timeout) return;
    this.timeout = setTimeout(() => {
      if (!this.state.initialized) {
        this.setState({
          initialized: true,
        });
      }
    }, 10000);
  }

  onResetError() {
    this.setState({ error: false, initialized: false, loaded: false });
  }

  render() {
    return (
      <Layout>
        <Router useErrorBoundary location={this.location} routes={this.routes}>
          {this.state.error
            ? <ErrorPage {...this.props}
              messageText={this.state.messageText}
              errorMsg={this.state.errorMsg || "Fehler"}
              messageHeader={this.state.messageHeader}
              onResetError={this.onResetError}
            />
            : <Outlet />
          }
          {CONFIG.NODE_ENV === "xdevelopment"
            ? <ReactLocationDevtools />
            : null
          }
        </Router>
      </Layout>
    );
  }
}

export default connect(store => {
  return {
    configStorage: store.configStorage,
    pageStorage: store.pageStorage
  };
})(App);
